export enum EnumTipoPeriodicidad {
  Mensual = 1,
  Bimensual,
  Trimestral,
  Semestral,
  Anual,
  Diario
}
